export default function getToday() {
  const d = new Date()

  const today = d.toLocaleString('fr-CA', {
    // fr-CA gives yyyy-mm-dd format for dates.
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  return today
}
